import { render } from "./CompanyActionsCell.vue?vue&type=template&id=a2e8f410&ts=true"
import script from "./CompanyActionsCell.vue?vue&type=script&lang=ts"
export * from "./CompanyActionsCell.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__